import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FilterItem, FilterType, InputType, PagingOptions, TextBoxOptions } from 'bnsights-control-library';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { JobCountsModel } from '../../shared/models/JobModels/JobCountsModel';
import { JobsService } from './../../shared/Services/JobsService.service';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';

@Component({
  selector: 'lib-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.css']
})
export class JobsComponent implements OnInit {

  ApiUrl = "/api/admin/Jobs/"
  searchTextBox: TextBoxOptions;
  JobCountsModel:JobCountsModel= new JobCountsModel();
  ProductionMode: boolean = false;
  IsStatisticsLoaded:boolean=false;

  EnqueuedForm = new FormGroup({});
  showEnqueuedFilter: boolean = false;
  EnqueuedPagingResult: any[] = [];
  EnqueuedPaging: PagingOptions;
  EnqueuedTextInputFilter: FilterItem;
  IsEnqueuedFilterLoaded: boolean = false;
  @ViewChild('EnqueuedPagingViewElement', { static: false }) EnqueuedInput: ElementRef;

  ScheduledForm = new FormGroup({});
  ScheduledPagingResult: any[] = [];
  ScheduledPaging: PagingOptions;
  IsScheduledFilterLoaded: boolean = false;
  @ViewChild('ScheduledPagingViewElement', { static: false }) ScheduledInput: ElementRef;

  ProcessingForm = new FormGroup({});
  ProcessingPagingResult: any[] = [];
  ProcessingPaging: PagingOptions;
  IsProcessingFilterLoaded: boolean = false;
  @ViewChild('ProcessingPagingViewElement', { static: false }) ProcessingInput: ElementRef;


  SucceededForm = new FormGroup({});
  SucceededPagingResult: any[] = [];
  SucceededPaging: PagingOptions;
  IsSucceededFilterLoaded: boolean = false;
  @ViewChild('SucceededPagingViewElement', { static: false }) SucceededInput: ElementRef;

  FailedForm = new FormGroup({});
  FailedPagingResult: any[] = [];
  FailedPaging: PagingOptions;
  IsFailedFilterLoaded: boolean = false;
  @ViewChild('FailedPagingViewElement', { static: false }) FailedInput: ElementRef;

  DeletedForm = new FormGroup({});
  DeletedPagingResult: any[] = [];
  DeletedPaging: PagingOptions;
  IsDeletedFilterLoaded: boolean = false;
  @ViewChild('DeletedPagingViewElement', { static: false }) DeletedInput: ElementRef;

  language:string=""

  
   // Decorator wires up blockUI instance
  constructor( private authService:AuthService,private pageInfoService:PageInfoService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService, private JobsService: JobsService) {
  }
  async ngOnInit() {
    PageInfoService.PageTitle=this.utilityService.getResourceValue("Jobs")
    PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false}

    ];
    
    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language = await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    this.LoadStatistics();
  }


  ReinitializeEnqueuedPaging() {
    let element = this. EnqueuedInput as any;
    element.ReinitializePaging();
  }
  UpdateEnqueuedPaging() {
    let element = this.EnqueuedInput as any;
    element.UpdatePaging();
  }
  setEnqueuedListResult(result) {
    this.EnqueuedPagingResult = result
    this.utilityService.startBlockUI();
  }
  resetFilters() {
    this.EnqueuedForm.controls["searchTextBox"].setValue(null);
    let element = this.EnqueuedInput as any;
    element.ReinitializePaging();

  }

  ReinitializeScheduledPaging() {
    let element = this.ScheduledInput as any;
    element.ReinitializePaging();
  }
  UpdateScheduledPaging() {
    let element = this.ScheduledInput as any;
    element.UpdatePaging();
  }
  setScheduledListResult(result) {
    this.ScheduledPagingResult = result
    this.utilityService.stopBlockUI();
  }

  ReinitializeProcessingPaging() {
    let element = this.ProcessingInput as any;
    element.ReinitializePaging();
  }
  UpdateProcessingPaging() {
    let element = this.ProcessingInput as any;
    element.UpdatePaging();
  }
  setProcessingListResult(result) {
    this.ProcessingPagingResult = result
    this.utilityService.stopBlockUI()

  }

  ReinitializeSucceededPaging() {
    let element = this.SucceededInput as any;
    element.ReinitializePaging();
  }
  UpdateSucceededPaging() {
    let element = this.SucceededInput as any;
    element.UpdatePaging();
  }
  setSucceededListResult(result) {
    this.SucceededPagingResult = result
    this.utilityService.stopBlockUI();
  }

  ReinitializeFailedPaging() {
    let element = this.FailedInput as any;
    element.ReinitializePaging();
  }
  UpdateFailedPaging() {
    let element = this.FailedInput as any;
    element.UpdatePaging();
  }
  setFailedListResult(result) {
    this.FailedPagingResult = result
    this.utilityService.stopBlockUI()
  }


  ReinitializeDeletedPaging() {
    let element = this.DeletedInput as any;
    element.ReinitializePaging();
  }
  UpdateDeletedPaging() {
    let element = this.DeletedInput as any;
    element.UpdatePaging();
  }
  setDeletedListResult(result) {
    this.DeletedPagingResult = result
    this.utilityService.stopBlockUI()

  }

  LoadStatistics() {
    this.JobsService.LoadStatistics().subscribe((result) => {
      let Lists = result as any
      this.JobCountsModel.Enqueued=Lists.enqueued
      this.JobCountsModel.Succeeded=Lists.succeeded
      this.JobCountsModel.Scheduled=Lists.scheduled
      this.JobCountsModel.Processing=Lists.processing
      this.JobCountsModel.Failed=Lists.failed
      this.JobCountsModel.Deleted=Lists.deleted
      setTimeout(() => {
        this.IsStatisticsLoaded = true;

      }, 10);
    })
  }

  

  LoadEnqueuedJobs() 
  {
    this.IsEnqueuedFilterLoaded = false;
    this.IsScheduledFilterLoaded = false;
    this.IsProcessingFilterLoaded = false;
    this.IsSucceededFilterLoaded = false;
    this.IsFailedFilterLoaded = false;

    this.IsDeletedFilterLoaded = false;


    this.utilityService.startBlockUI
      // TextBox inti
      this.searchTextBox = new TextBoxOptions();
      this.searchTextBox.Name = "searchTextBox"
    this.searchTextBox.HideLabel = true
    this.searchTextBox.Type = InputType.Text
    this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName")

      this.EnqueuedTextInputFilter = new FilterItem();
      this.EnqueuedTextInputFilter.FormControlName = "searchTextBox"
      this.EnqueuedTextInputFilter.ActionParameterName = "searchText"
      this.EnqueuedTextInputFilter.IsFormControl = true
      this.EnqueuedTextInputFilter.FilterType = FilterType.TextBox

      this.EnqueuedPaging = new PagingOptions();
      this.EnqueuedPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetQueueListByFilter';
      this.EnqueuedPaging.OnKeyPressFiltersControlNames = ["searchTextBox"]
      this.EnqueuedPaging.Filters = [ this.EnqueuedTextInputFilter]
      this.EnqueuedPaging.ValidationToken = this.authService.authorizationHeaderValue()
      setTimeout(() => {

        this.IsEnqueuedFilterLoaded = true;
      }, 10);
  
  }


  LoadScheduledJobs() 
  {
    this.IsEnqueuedFilterLoaded = false;
    this.IsScheduledFilterLoaded = false;
    this.IsProcessingFilterLoaded = false;
    this.IsSucceededFilterLoaded = false;
    this.IsFailedFilterLoaded = false;
    this.IsDeletedFilterLoaded = false;
    this.utilityService.startBlockUI
     
      this.ScheduledPaging = new PagingOptions();
      this.ScheduledPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetScheduledListByFilter';
      this.ScheduledPaging.ValidationToken = this.authService.authorizationHeaderValue()
      setTimeout(() => {
        this.IsScheduledFilterLoaded = true;
      }, 10);
  
  }

  LoadProcessingJobs() 
  {
    this.IsEnqueuedFilterLoaded = false;
    this.IsScheduledFilterLoaded = false;
    this.IsProcessingFilterLoaded = false;
    this.IsSucceededFilterLoaded = false;
    this.IsFailedFilterLoaded = false;
    this.IsDeletedFilterLoaded = false;
    this.utilityService.startBlockUI
     
      this.ProcessingPaging = new PagingOptions();
      this.ProcessingPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetProcessingListByFilter';
      this.ProcessingPaging.ValidationToken = this.authService.authorizationHeaderValue()
      setTimeout(() => {
        this.IsProcessingFilterLoaded = true;
      }, 10);
  
  }

  LoadSucceededJobs() 
  {
    this.IsEnqueuedFilterLoaded = false;
    this.IsScheduledFilterLoaded = false;
    this.IsProcessingFilterLoaded = false;
    this.IsSucceededFilterLoaded = false;
    this.IsFailedFilterLoaded = false;
    this.IsDeletedFilterLoaded = false;

    this.utilityService.startBlockUI
     
      this.SucceededPaging = new PagingOptions();
      this.SucceededPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetSucceededListByFilter';
      this.SucceededPaging.ValidationToken = this.authService.authorizationHeaderValue()
      setTimeout(() => {
        this.IsSucceededFilterLoaded = true;
        }, 10);
  
  }

  LoadFailedJobs() 
  {
    this.IsEnqueuedFilterLoaded = false;
    this.IsScheduledFilterLoaded = false;
    this.IsProcessingFilterLoaded = false;
    this.IsSucceededFilterLoaded = false;
    this.IsFailedFilterLoaded = false;
    this.IsDeletedFilterLoaded = false;

    this.utilityService.startBlockUI
     
      this.FailedPaging = new PagingOptions();
      this.FailedPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetFailedListByFilter';
      this.FailedPaging.ValidationToken = this.authService.authorizationHeaderValue()
      setTimeout(() => {
        this.IsFailedFilterLoaded = true;
      }, 10);
  
  }

  LoadDeletedJobs() 
  {
    this.IsEnqueuedFilterLoaded = false;
    this.IsScheduledFilterLoaded = false;
    this.IsProcessingFilterLoaded = false;
    this.IsSucceededFilterLoaded = false;
    this.IsFailedFilterLoaded = false;
    this.IsDeletedFilterLoaded = false;

    this.utilityService.startBlockUI
     
      this.DeletedPaging = new PagingOptions();
      this.DeletedPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetDeletedListByFilter';
      this.DeletedPaging.ValidationToken = this.authService.authorizationHeaderValue()
      setTimeout(() => {
        this.IsDeletedFilterLoaded = true;
      }, 10);
  
  }

}
